import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RestApiService {

  constructor(private http: HttpClient) { }

  public async getAllWorks(): Promise<any> {
    return await this.http.get('./rest/allworks').toPromise();
  }

  public async getAvailableWorks(): Promise<any> {
    return await this.http.get('./rest/availableworks').toPromise();
  }

  public async getAvailablePrints(): Promise<any> {
    return await this.http.get('./rest/availableprints').toPromise();
  }

  public async getPastWorks(): Promise<any> {
    return await this.http.get('./rest/pastworks').toPromise();
  }

  public async getOriginal(sku: string): Promise<any> {
    return await this.http.get('./rest/original/' + sku).toPromise();
  }

  public async getPrint(sku: string): Promise<any> {
    return await this.http.get('./rest/print/' + sku).toPromise();
  }

  public async getPastWork(sku: string): Promise<any> {
    return await this.http.get('./rest/past/' + sku).toPromise();
  }

  public async getSKUCartInfo(sku: string): Promise<any> {
    return await this.http.get('./rest/sku/' + sku).toPromise();
  }

  public async postOrderRequest(order_info: any): Promise<any> {
    return await this.http.post('./rest/order', order_info).toPromise();
  }

  public async paid(order_id: string): Promise<any> {
    return await this.http.post('./rest/paid', {order_id: order_id}).toPromise();
  }

  public async contact(contact_info: any): Promise<any> {
    return await this.http.post('./rest/contact', contact_info).toPromise();
  }

  @Output() orderNumber: EventEmitter<string> = new EventEmitter<string>();
  public raiseOrderNumber(order_info: any) {
    this.orderNumber.emit(order_info);
  }
}
